export default {"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"iframe-container\">\r\n  <iframe src=\"web/#/WebinarsMenu\" class=\"iframe\"></iframe>  \r\n</div>";
},"useData":true};